// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewLayout_modal-scroll__dhDQV","container":"ViewLayout_container__zog7h"};